import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pricings")({
  loader: () => {
    throw redirect({ to: "/pricing", replace: true });
  },
});
